export const ECOMMERCE_PLANALTO_URL =
	'https://e-commerce.passagensweb.net/esipe/Venda/planaltotransportes/Principal'
